import { getApi } from "../client/apiClient";
import type { HttpClient } from "../client/types";
import type {
  MessageResponse,
  PaginatedResponse,
  BuildingOptionsResponse,
  ReportDataResponse,
} from "../client/types/common.types";
import type {
  GetNewsRequest,
  New,
  CreateMaintenanceNewRequest,
  FirstAidStationNewCreate,
  CreatePoolRegulationNewRequest,
  CreateAdverseEventNewRequest,
  GetNewsReportPreviewRequest,
  NewReportDataItem,
  GetBuildingsWithNewsRequest,
  GetNewsReportDataRequest,
  UpdateNewRequest,
} from "../client/types/new.types";

const createNewEndpoints = (client: HttpClient = getApi()) => ({
  getNews: async (params?: GetNewsRequest): Promise<PaginatedResponse<New>> => {
    const { data: response } = await client.get<PaginatedResponse<New>>(
      "/news",
      { params }
    );
    return response;
  },
  getNewById: async (news_id: string): Promise<New> => {
    const { data: response } = await client.get<New>(`/news/${news_id}`);
    return response;
  },
  createMaintenanceNew: async (
    data: CreateMaintenanceNewRequest
  ): Promise<New> => {
    const { data: response } = await client.post<New>(
      "/news/maintenance",
      data
    );
    return response;
  },
  createFirstAidStationNew: async (
    data: FirstAidStationNewCreate
  ): Promise<New> => {
    const { data: response } = await client.post<New>(
      "/news/first-aid-station",
      data
    );
    return response;
  },
  createPoolRegulationNew: async (
    data: CreatePoolRegulationNewRequest
  ): Promise<New> => {
    const { data: response } = await client.post<New>(
      "/news/pool-regulation",
      data
    );
    return response;
  },
  createAdverseEventNew: async (
    data: CreateAdverseEventNewRequest
  ): Promise<New> => {
    const { data: response } = await client.post<New>(
      "/news/adverse-event",
      data
    );
    return response;
  },
  getNewsReportPreview: async (
    params?: GetNewsReportPreviewRequest
  ): Promise<PaginatedResponse<NewReportDataItem>> => {
    const { data: response } = await client.get<
      PaginatedResponse<NewReportDataItem>
    >("/news/report-preview", { params });
    return response;
  },
  updateNew: async (
    news_id: string,
    data: UpdateNewRequest
  ): Promise<New> => {
    const { data: response } = await client.patch<New>(
      `/news/${news_id}`,
      data
    );
    return response;
  },
  deleteNew: async (new_id: string): Promise<MessageResponse> => {
    const { data: response } = await client.delete<MessageResponse>(
      `/news/${new_id}`
    );
    return response;
  },
  getBuildingsWithNews: async (
    params: GetBuildingsWithNewsRequest
  ): Promise<BuildingOptionsResponse> => {
    const { data: response } = await client.get<BuildingOptionsResponse>(
      "/news/buildings-with-news",
      { params }
    );
    return response;
  },
  getNewsReportData: async (
    params: GetNewsReportDataRequest
  ): Promise<ReportDataResponse<NewReportDataItem>> => {
    const { data: response } = await client.get<
      ReportDataResponse<NewReportDataItem>
    >("/news/report-data", { params });
    return response;
  },
});

export type NewEndpoints = ReturnType<typeof createNewEndpoints>;

export const newEndpoints = createNewEndpoints();
